/**
 * プロフィール設定誘導モーダルの「あとで設定する」スヌーズ管理（Issue #1003）
 *
 * 「あとで設定する」押下時に、再表示可能になる時刻（現在 + 7日）を
 * ローカルストレージへ保存し、期限内はモーダルを再表示しない。
 *
 * SSR（window 不在）・ローカルストレージ未対応・例外・不正値の場合は
 * すべて安全側（再表示可）にフォールバックする。
 */

const SNOOZE_KEY = "profileNudgeSnoozedUntil";
const SNOOZE_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7日

/**
 * モーダルを表示してよいか判定する。
 * 期限が未保存・不正値・期限切れの場合は true（表示可）を返す。
 */
export function canShowProfileNudge(): boolean {
  if (typeof window === "undefined") return true;
  try {
    const raw = localStorage.getItem(SNOOZE_KEY);
    if (raw === null) return true;
    const until = Number(raw);
    if (!Number.isFinite(until)) return true;
    return Date.now() >= until;
  } catch {
    return true;
  }
}

/**
 * 現在時刻から7日後までモーダルを非表示にする。
 */
export function snoozeProfileNudge(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(SNOOZE_KEY, String(Date.now() + SNOOZE_DURATION_MS));
  } catch {
    // localStorage unavailable (private browsing etc.)
  }
}
